/* eslint-disable @typescript-eslint/no-unsafe-assignment */
/* eslint-disable max-lines */
import * as Yup from 'yup';
import { isValidPhoneNumber } from 'react-phone-number-input';
import { Owner, userType } from '../../lib/Redux/Types/ownershipForm/OwnershipFormResponse.data';
import {
  ContactTypeOptions,
  SalutationsTypeOptions,
} from '../../screens/newReferral/NewReferralConstant';
import {
  DisbursementFrequencyOptions,
  OwnershipTypeOptions,
} from '../../screens/ownership/OwnershipFormConstants';
import { BlanketForm, BlanketFormField } from '../blanketForm/BlanketFormConstants';

export const OwnershipDetailsForms: BlanketForm = {
  heading: 'Ownership Details',
  name: '',
  isCollapsible: false,
  fields: [
    {
      name: 'displayName',
      label: 'Display Name',
      size: 'L',
      type: 'Text',
    },
    {
      name: 'email',
      label: 'Email',
      size: 'L',
      type: 'Text',
    },
    {
      name: 'type',
      label: 'Type',
      size: 'L',
      type: 'Select',
      options: OwnershipTypeOptions,
    },
  ],
};

export const personalDetailsFields: BlanketFormField[] = [
  {
    name: 'title',
    label: 'Title',
    size: 'XXS',
    type: 'Select',
    options: SalutationsTypeOptions,
  },
  {
    name: 'firstName',
    label: 'First Name',
    size: 'M',
    type: 'Text',
  },
  {
    name: 'lastName',
    label: 'Last Name',
    size: 'M',
    type: 'Text',
  },
  { name: 'phoneNumber', label: 'Contact Number', size: 'L', type: 'PhoneNumber' },
  {
    name: 'alternateNumber',
    label: 'Alternate Contact Number',
    size: 'L',
    type: 'PhoneNumber',
  },
  {
    name: 'email',
    label: 'Email',
    size: 'L',
    type: 'Text',
  },
  { name: 'preferredName', label: 'Preferred Name', size: 'L', type: 'Text' },
  {
    name: 'corporation',
    label: 'Corporation Name',
    size: 'L',
    type: 'Text',
    dependencyQuestionName: 'type',
    dependencyAnswer: 'Business',
  },
  {
    name: 'acn',
    label: 'ACN',
    size: 'L',
    type: 'Text',
    dependencyQuestionName: 'type',
    dependencyAnswer: 'Business',
  },
  {
    name: 'corporation',
    label: 'Corporation Name',
    size: 'L',
    type: 'Text',
    dependencyQuestionName: 'type',
    dependencyAnswer: 'Trust',
  },
  {
    name: 'acn',
    label: 'ACN',
    size: 'L',
    type: 'Text',
    dependencyQuestionName: 'type',
    dependencyAnswer: 'Trust',
  },
  {
    name: 'dob',
    label: 'Date of Birth',
    size: 'L',
    type: 'Date',

    // validations: { isRequired: true, minLength: 10, regex: /^[0-9][0-9]+$/ },
  },
  {
    name: 'postalAddress',
    label: 'Postal Address',
    size: 'XXL',
    type: 'Address',
    props: { secondFieldName: 'addressComponents' },
  },
  {
    name: 'preferredContactMethod',
    label: 'Preferred contact method',
    type: 'Radio',
    size: 'XXL',
    options: [
      { label: 'SMS', value: 'SMS' },
      { label: 'E-mail', value: 'EMAIL' },
      { label: 'Phone call', value: 'CALL' },
    ],
    wrapperStyle: {
      marginTop: '1.5em',
    },
  },
  {
    name: '',
    label: 'Emergency contact details',
    type: 'Heading',
    props: {
      headingVariant: 'body2',
    },
    size: 'XXL',
  },
  { name: 'emergencyContact.name', label: 'Name', size: 'L', type: 'Text' },
  { name: 'emergencyContact.phoneNumber', label: 'Contact Number', size: 'L', type: 'PhoneNumber' },
  { name: 'emergencyContact.email', label: 'Email', size: 'L', type: 'Text' },
  {
    name: '',
    label: 'Power of Attorney',
    type: 'Heading',
    props: {
      headingVariant: 'body2',
    },
    size: 'XXL',
  },
  { name: 'poaContact.name', label: 'Name', size: 'L', type: 'Text' },
  { name: 'poaContact.phoneNumber', label: 'Contact Number', size: 'L', type: 'PhoneNumber' },
  { name: 'poaContact.email', label: 'Email', size: 'L', type: 'Text' },
];

export const helpfulContactFields: BlanketFormField[] = [
  { name: '', label: 'Contact Details', size: 'XXL', type: 'Heading' },
  {
    name: 'contactType',
    label: 'Contact Type',
    size: 'L',
    type: 'Select',
    options: ContactTypeOptions,
  },
  { name: 'businessName', label: 'Business Name', size: 'L', type: 'Text' },
  { name: 'contactName', label: 'Name', size: 'L', type: 'Text' },
  { name: 'phoneNumber', label: 'Contact Number', size: 'L', type: 'PhoneNumber' },
  { name: 'email', label: 'Email', size: 'L', type: 'Text' },
];

export const PersonalDetailsForms: BlanketForm = {
  name: 'primaryOwner',
  heading: 'Personal details',
  isCollapsible: true,
  fields: personalDetailsFields,
};
export const OwnersForm: BlanketForm = {
  name: 'secondaryOwners',
  heading: 'Secondary owners',
  isCollapsible: true,
  canBeMultiple: true,
  fields: [
    {
      name: '',
      label: 'Owner details',
      size: 'XXL',
      type: 'Heading',
      props: { headingVariant: 'body2' },
    },
    ...personalDetailsFields,
  ],
  countLabel: 'Select number of secondary owners',
};
export const FinancialDetailsForm: BlanketForm = {
  name: 'financialDetails',
  heading: 'Financial details',
  isCollapsible: true,
  fields: [
    { name: 'bankName', label: 'Bank', size: 'L', type: 'Text' },
    { name: 'accountName', label: 'Account Name', size: 'L', type: 'Text' },
    { name: 'bsb', label: 'BSB Number', size: 'L', type: 'Text' },
    { name: 'accountNumber', label: 'Account Number', size: 'L', type: 'Text' },
    {
      name: '',
      label: 'Disbursement frequency',
      type: 'Heading',
      props: {
        headingVariant: 'body2',
      },
      size: 'XXL',
    },
    {
      name: 'disbursementFrequency',
      label: '',
      type: 'Radio',
      size: 'XL',
      options: DisbursementFrequencyOptions,
    },
    {
      name: '',
      label: `We can pay the following bills on your behalf from the collected rent. They will be paid quarterly on receipt or annually (for landlords’ insurance and smoke alarm compliance)`,
      type: 'Heading',
      size: 'XXL',
      props: {
        headingVariant: 'subtitle1',
      },
    },
    {
      name: '',
      label: `If you choose to pay any of these bills yourself, you are required to advise each entity of your mailing
        address, and the ACT Revenue Office of the date of the tenancy commencement.`,
      type: 'Heading',
      size: 'XXL',
      props: {
        headingVariant: 'subtitle1',
      },
    },
    {
      name: '',
      label: `I would like you to pay the following on my behalf from the collected rent: `,
      type: 'Heading',
      size: 'XXL',
      props: {
        headingVariant: 'subtitle1',
        color: 'primary',
      },
    },
    {
      name: 'disbursementAnnual',
      label: '',
      type: 'Checkbox',
      size: 'XXL',
      options: [
        { label: 'Smoke alarm compliance', value: 'paySmokeAlarm', size: 'S' },
        { label: 'Landlords insurance', value: 'payLandlordInsurance', size: 'S' },
        {
          label: 'Tax depreciation schedule (one off cost)',
          value: 'payTaxDepreciation',
          size: 'S',
        },
      ],
    },
    {
      name: 'Insurance',
      label: 'Insurance details',
      size: 'XL',
      type: 'Heading',
      props: {
        headingVariant: 'body2',
      },
    },
    {
      name: 'buildingInsuranceDetails.provider',
      label: 'Building insurance provider',
      size: 'L',
      type: 'Text',
    },
    {
      name: 'buildingInsuranceDetails.policyNumber',
      label: 'Policy number',
      size: 'L',
      type: 'Text',
    },
    {
      name: 'landlordInsuranceDetails.provider',
      label: 'Landlord insurance provider',
      size: 'L',
      type: 'Text',
    },
    {
      name: 'landlordInsuranceDetails.policyNumber',
      label: 'Policy number',
      size: 'L',
      type: 'Text',
    },
    {
      name: 'haveWill',
      label: 'Do you have Will?',
      type: 'Radio',
      size: 'XL',
      options: [
        { label: 'Yes', value: 'true' },
        { label: 'No', value: 'false' },
      ],
      wrapperStyle: {
        marginTop: '1em',
      },
    },
    {
      name: 'ownOtherProperties',
      label: 'Do you own other property?',
      type: 'Radio',
      size: 'XL',
      options: [
        { label: 'Yes', value: 'true' },
        { label: 'No', value: 'false' },
      ],
    },
    {
      name: 'otherPropertyLocation',
      type: 'Text',
      size: 'L',
      label: 'Where is the property located?',
      dependencyQuestionName: 'financialDetails.ownOtherProperties',
      dependencyAnswer: 'true',
    },
    {
      name: 'otherPropertyManager',
      type: 'Text',
      size: 'L',
      label: 'Who is your current property manager?',
      dependencyQuestionName: 'financialDetails.ownOtherProperties',
      dependencyAnswer: 'true',
    },
  ],
};
export const ContactsForm: BlanketForm = {
  name: 'contacts',
  heading: 'Helpful contacts',
  isCollapsible: true,
  fields: helpfulContactFields,
  canBeMultiple: true,
  countLabel: 'Please select number of contacts you want to enter',
};
export const PreferredServicesForm: BlanketForm = {
  name: 'preferredTrades',
  heading: 'Professional services information',
  isCollapsible: true,
  fields: [
    {
      name: '',
      label:
        'Having knowledge of your professional services enables us to assist you at tax time or to provide you additional support as required.',
      type: 'Heading',
      size: 'XXL',
      props: {
        headingVariant: 'subtitle1',
      },
    },
    {
      name: 'preferredTrades',
      label: 'Do you have a preferred:',
      type: 'Checkbox',
      size: 'XXL',
      options: [
        { label: 'Solicitor/Conveyancer', value: 'solicitor', size: 'S' },
        { label: 'Mortgage broker', value: 'mortgageBroker', size: 'S' },
        { label: 'Financial advisor', value: 'financialAdvisor', size: 'S' },
        { label: 'Insurance broker', value: 'insuranceBroker', size: 'S' },
        { label: 'Accountant', value: 'accountant', size: 'S' },
      ],
    },
  ],
  canBeMultiple: false,
};

export const Comments: BlanketForm = {
  name: 'comment',
  heading: 'Comments For Owner',
  isCollapsible: false,
  fields: [{ name: 'message', label: 'Provide your comments', size: 'XXL', type: 'Text' }],
};

const withEmergencyContactDefaults = (owner: Owner): Owner => ({
  ...owner,
  emergencyContact: {
    name: owner.emergencyContact?.name || '',
    phoneNumber: owner.emergencyContact?.phoneNumber || '',
    email: owner.emergencyContact?.email || '',
  },
  // Same null-vs-{}-vs-undefined touched-propagation issue as emergencyContact above:
  // a null `identification` means Formik can't mark `identification.type` touched on
  // submit, so its required error would compute but never actually display.
  identification: {
    type: owner.identification?.type || '',
    document: owner.identification?.document,
  },
});

export const withOwnerFormDefaults = (owner?: Owner | null): Owner | undefined =>
  owner ? withEmergencyContactDefaults(owner) : undefined;

export const withOwnerListFormDefaults = (owners: Owner[]): Owner[] =>
  owners.map(withEmergencyContactDefaults);

const isValidPhoneOrEmpty = (value?: string | null) => !value || isValidPhoneNumber(value);

const requiredPhoneNumber = (message: string) =>
  Yup.string()
    .typeError('Required')
    .required(message)
    .test('is-valid-phone', 'Enter a valid phone number', isValidPhoneOrEmpty);

const optionalPhoneNumber = () =>
  Yup.string()
    .typeError('Required')
    .nullable()
    .test('is-valid-phone', 'Enter a valid phone number', isValidPhoneOrEmpty);

// Each of these takes the "should this be required" condition first, so every field in
// the shape below reads as one line: `field: requiredString(condition, message)`.
const requiredString = (when: boolean, message: string) =>
  when ? Yup.string().typeError('Required').required(message) : Yup.string().nullable();

const requiredMixed = (when: boolean, message: string) =>
  when ? Yup.mixed().required(message) : Yup.mixed().nullable();

const requiredPhone = (when: boolean, message: string) =>
  when ? requiredPhoneNumber(message) : optionalPhoneNumber();

// Matches the three owner-shaped sections in referral-forms/*/OwnershipForm.json — each
// name is the actual JSON section name, since that's what determines their quirks below.
type OwnerFormKind = 'primaryOwner' | 'ownerDetails' | 'secondaryOwners';

const buildOwnerValidationShape = (formKind: OwnerFormKind, isOwnerFilling: boolean) => {
  // secondaryOwners never requires phone/DOB/postal/emergency contact for anyone — the
  // backend template has no isRequired rule on those fields there, unlike primaryOwner
  // and ownerDetails where it's gated on the owner actually being the one filling it in.
  const requireContactDetails = isOwnerFilling && formKind !== 'secondaryOwners';
  // Only the primaryOwner form renders an "Emergency Contact Details" section — ownerDetails
  // and secondaryOwners never do. Requiring it regardless would demand a value for a field
  // the user can never see.
  const includeEmergencyContact = formKind === 'primaryOwner';
  // Identification Details is required whenever the owner themselves is filling the form
  // in — including on secondaryOwners, where contact details are never required but ID
  // still is (an agent won't have a co-owner's ID document on hand).
  const requireIdentification = isOwnerFilling;

  return Yup.object().shape({
    title: Yup.string().typeError('Required').required('Required'),
    firstName: Yup.string().required('First Name is required'),
    lastName: Yup.string().required('Last Name is required'),
    email: Yup.string().required('Email is required').email('Enter valid email'),
    phoneNumber: requiredPhone(requireContactDetails, 'Phone number is Required'),
    postalAddress: requiredString(requireContactDetails, 'Postal Address is required'),
    dob: requiredString(requireContactDetails, 'Date of Birth is required'),
    identification: Yup.object()
      .transform((value) => value ?? {})
      .shape({
        type: requiredString(requireIdentification, 'Identification Type is required'),
        document: requiredMixed(requireIdentification, 'Attachment is required'),
      }),
    // When the form doesn't render an Emergency Contact section, the key is omitted
    // from the shape entirely rather than validated against an empty/nullable
    // placeholder — Yup then leaves whatever value is there completely unchecked,
    // instead of us having to reason about what "valid but unvalidated" means.
    ...(includeEmergencyContact && {
      emergencyContact: Yup.object()
        .transform((value) => value ?? {})
        .shape({
          name: requiredString(requireContactDetails, 'Emergency contact name is required'),
          phoneNumber: requiredPhone(requireContactDetails, 'Emergency contact number is required'),
          email: Yup.string().email('Enter valid email').nullable(),
        }),
    }),
    poaContact: Yup.object()
      .shape({
        email: Yup.string().email('Enter valid email').nullable(),
      })
      .nullable(),
  });
};

export const getOwnershipFormValidation = (userType?: userType) => {
  const isAgent = userType === 'Agent';
  const isOwnerFilling = userType === 'PrimaryOwner' || userType === 'SecondaryOwner';
  if (userType === 'SecondaryOwner') {
    return Yup.object().shape({
      ownerDetails: buildOwnerValidationShape('ownerDetails', isOwnerFilling),
    });
  }
  return Yup.object().shape({
    email: isAgent
      ? Yup.string().required('Email is required').email('Enter valid email')
      : Yup.string().nullable(),
    primaryOwner: buildOwnerValidationShape('primaryOwner', isOwnerFilling),
    secondaryOwners: Yup.array().of(buildOwnerValidationShape('secondaryOwners', isOwnerFilling)),
  });
};

export const NAX_AGENCY_CODE = 'NAX';
